import React, { useEffect, useState } from 'react';
import { Image } from '@/components';
import { TFunction } from 'next-i18next';
import { ListOfParticipants } from './list';
import { useListOfParticipantsQuery } from '../../api';
import { MessageDataSocket, ParticipantsType } from '../../const';
import { LotteryGameStatus, LotterySocketMethod, LotteryTicketStatus } from '@/layouts/shared';
import Confetti from './Confetti';
type LotteryProps = {
  t: TFunction;
  gameId: string;
  showLotteryBtn: () => void;
  messageData: MessageDataSocket;
  gameStatus: string;
  isAuth: boolean;
  liveStreamId: number;
};

export const LotteryPartial = (props: LotteryProps) => {
  const { t, gameId, showLotteryBtn, messageData, gameStatus, isAuth, liveStreamId } = props;
  const [participants, setParticipants] = useState<ParticipantsType[]>([]);
  const [status, setStatus] = useState<string>(gameStatus);
  const [ticketStatus, setTicketStatus] = useState<string>(
    gameStatus === LotteryGameStatus.Pending ? LotteryTicketStatus.Pending : LotteryTicketStatus.CloseList
  );

  const [countUser, setCountUser] = useState<number>(0);
  const { refetch: refetchParticipants } = useListOfParticipantsQuery(
    {
      lottery_game_id: gameId,
      offset: 0,
      limit: 5,
      status: ticketStatus,
    },
    {
      enabled: false,
      retry: false,
      onSuccess: ({ data, total_records }) => {
        if (!data) {
          setCountUser(0);
          return setParticipants([]);
        }
        let _p = data
          .sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime())
          .map((d) => {
            return {
              number: d.number,
              fullName: d.users.fullname,
            };
          });
        setCountUser(total_records);
        setParticipants(_p);
      },
    }
  );

  useEffect(() => {
    if (messageData?.method === LotterySocketMethod.UserConfirmTicket) {
      let _p = {
        number: messageData.data?.number || 0,
        fullName: messageData.data?.users?.fullname || '',
      };
      setCountUser((prev) => prev + 1);
      setParticipants((prev: any) => {
        if (prev.length > 4) {
          return [...prev.slice(0, 4), _p];
        }
        return [...prev, _p];
      });
    }
    if (messageData?.method === LotterySocketMethod.OpenLottery) {
      setTicketStatus(LotteryTicketStatus.Pending);
    }

    if (messageData?.method === LotterySocketMethod.CloseListLottery) {
      setStatus(LotteryGameStatus.Starting);
      setTicketStatus(LotteryTicketStatus.CloseList);
    }
    if (messageData?.method === LotterySocketMethod.AdminPickTicketLottery) {
      setStatus(LotteryGameStatus.Ended);
    }
  }, [messageData]);
  useEffect(() => {
    if (gameId) refetchParticipants();
  }, [liveStreamId, gameId, refetchParticipants, ticketStatus]);
  return (
    <>
      <div
        className="tw-flex tw-flex-col tw-items-center tw-w-max tw-cursor-pointer"
        onClick={isAuth ? showLotteryBtn : () => {}}
      >
        <Image src="/confetti-flat.gif" className="tw-w-10 tw-h-10 md:tw-w-16 md:tw-h-16" alt="confetti"></Image>
        <div className="tw-border tw-rounded-5 tw-border-white tw-w-12 tw-h-4 md:tw-w-20 md:tw-h-5 tw-flex tw-items-center tw-justify-center">
          <Image
            src="/lottery.svg"
            className="tw-w-6 tw-h-3 md:tw-w-10 md:tw-h-5"
            alt="lottery"
            objectFit="contain"
          ></Image>
        </div>
      </div>
      {status === LotteryGameStatus.Pending && (
        <Confetti
          wrapperClass="tw-mt-2 tw-pt-1 md:tw-mt-3 tw-bg-black tw-bg-opacity-30 tw-text-white tw-rounded-full tw-px-2 md:tw-px-3 tw-pb-1 tw-flex tw-items-end"
          title={t('detail.label.start-lottery')}
          key="pending"
        />
      )}
      {countUser > 0 && (
        <div className="tw-mt-2 tw-text-xs md:tw-text-13 tw-text-white">
          {countUser} {t('detail.label.user-join')}
        </div>
      )}

      <div className="tw-mt-3 md:tw-mt-5">
        <ListOfParticipants participants={participants} />
      </div>
      {status === LotteryGameStatus.Starting && (
        <Confetti
          wrapperClass="tw-mt-1 md:tw-mt-3 tw-bg-black tw-bg-opacity-30 tw-text-white tw-rounded-full tw-px-3 tw-py-1 tw-flex tw-items-end"
          title={t('detail.label.end-list')}
          key="starting"
        />
      )}
    </>
  );
};
